import { render } from "./freeCheckService.vue?vue&type=template&id=387ddffe&scoped=true&ts=true"
import script from "./freeCheckService.vue?vue&type=script&lang=ts"
export * from "./freeCheckService.vue?vue&type=script&lang=ts"

import "./freeCheckService.vue?vue&type=style&index=0&id=387ddffe&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387ddffe"]])

export default __exports__